import React, { useState, useRef } from 'react'
import Timer from '../../timer/timer';
import Video from '../../video/video';
import Audio from '../../audio/audio';
import Wheel from '../wheel/Wheel';
import "./index.css";

import { memo } from 'react';
import Modal from 'react-modal';

import styled, { keyframes } from 'styled-components';
import { fadeIn } from 'react-animations';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: 'none',
        border: 'none',
    },
};


const AnimationSlide = keyframes`${fadeIn}`;

const SlideDownInDiv = styled.div`
  animation: 2s ${AnimationSlide};
`;

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const MidwayGame = (props) => {
    const actorName = "BILLIE";
    const actorTitle = "Carnival Baker";
    const playVideo = useRef(null);
    const playAudio = useRef(null);
    const timerRef = useRef(null);

    const posterURL = './bgs/CarnivalBG.png';

    const congratulateVideoURL = './videos/5_2_Solution.mp4';

    const waitingVideoURL = './videos/waitings/Billie_Waiting.mp4';

    const promptVideos = ['./videos/CNE-11-Billie-Promt-01.mp4', './videos/CNE-11-Billie-Promt-02.mp4', './videos/CNE-11-Billie-Promt-03.mp4'];

    const [promptIndex, setPromptIndex] = useState(null);

    const [currentVideoURL, setCurrentVideoURL] = useState(null)

    const [currentClue, setCurrentClue] = useState(1);
    const [currentCoaster, setCurrentCoaster] = useState(1);
    const [currentCabin, setCurrentCabin] = useState(2);
    const [currentBumpCar, setCurrentBumpCar] = useState(3);

    let btnRef = useRef();

    const clue1 = useRef();
    const clue2 = useRef();
    const clue3 = useRef();

    const coaster1 = useRef();
    const coaster2 = useRef();
    const coaster3 = useRef();

    const bumpcar1 = useRef(null);
    const bumpcar2 = useRef(null);
    const bumpcar3 = useRef(null);
    const bumpcar4 = useRef(null);
    const bumpcar5 = useRef(null);
    //modal
    const [isBlur, setIsBlur] = useState("blur");

    function showClear(event) {
        event.stopPropagation();
        setIsBlur("");
    }

    const [modalIsOpen, setIsOpen] = useState(false);

    const [gameOverModalIsOpen, setGameOverModalIsOpen] = useState(false);

    function openModal() {
        setIsBlur('blur');
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }
    function openGameOverModal() {
        setGameOverModalIsOpen(true);
    }

    function closeGameOverModal() {
        timerRef.current(props.initialTimeOut);
        setGameOverModalIsOpen(false);
    }
    function restartGame() {
        setGameOverModalIsOpen(false);
        props.goToStep(null, 'LandingPage');

    }

    //modal end

    const gotoFailed = (event, args) => {

        if (gameOverModalIsOpen) {

        } else {
            openGameOverModal();
        }
    }

    const solvedGame = () => {
        if (currentCabin === 1 && currentCoaster === 3 && currentBumpCar === 4) {
            return true;
        } else {
            return false;
        }
    }

    const playWaitingVideo = () => {
        setCurrentVideoURL(waitingVideoURL);
        playVideo.current(waitingVideoURL);

    }

    const handleSubmit = (event) => {

        event.preventDefault();
        if (solvedGame()) {
            if (btnRef.current) {
                btnRef.current.setAttribute("disabled", "disabled");
            }
            playVideo.current(congratulateVideoURL);
            setCurrentVideoURL(congratulateVideoURL);

        } else {
            if (promptIndex === null) {
                setPromptIndex(0);
                playVideo.current(promptVideos[0]);
            } else if (promptIndex === 0) {
                setPromptIndex(1);
                playVideo.current(promptVideos[1]);
            } else if (promptIndex === 1) {
                setPromptIndex(2);
                playVideo.current(promptVideos[2]);
            } else if (promptIndex === 2) {
                setPromptIndex(0);
                playVideo.current(promptVideos[0]);
            } else {
                setPromptIndex(0);
                playVideo.current(promptVideos[0]);
            }

        }

    }

    const updateVideoStatue = (value, src) => {

        if (value === "ended") {
            if (currentVideoURL === congratulateVideoURL) {
                props.goToStep(null, 'PalacePuzzle');
            } else if (waitingVideoURL === currentVideoURL) {
                playWaitingVideo();
            } else if (promptVideos.includes(currentVideoURL)) {
                playWaitingVideo();
            } else {
                playWaitingVideo();
            }

        }

    }

    const updateAudioStatue = (value) => {

    }

    const setUpWarningSound = () => {
        if (playAudio.current) {
            playAudio.current('./musics/30SecondTimer.mp3');
        }
    }

    const swapClue = () => {

        clue1.current.style.zIndex = 0;
        clue2.current.style.zIndex = 0;
        clue3.current.style.zIndex = 0;

        if (currentClue === 1) {
            clue2.current.style.zIndex = 1;
            setCurrentClue(2);
        } else if (currentClue === 2) {
            clue3.current.style.zIndex = 1;
            setCurrentClue(3);
        } else if (currentClue === 3) {
            clue1.current.style.zIndex = 1;
            setCurrentClue(1);
        }
    }
    const swapCoaster = () => {

        coaster1.current.style.zIndex = 0;
        coaster2.current.style.zIndex = 0;
        coaster3.current.style.zIndex = 0;

        if (currentCoaster === 1) {
            coaster2.current.style.zIndex = 1;
            setCurrentCoaster(2);
        } else if (currentCoaster === 2) {
            coaster3.current.style.zIndex = 1;
            setCurrentCoaster(3);
        } else if (currentCoaster === 3) {
            coaster1.current.style.zIndex = 1;
            setCurrentCoaster(1);
        }
    }
    const updateCabin = (args) => {
        setCurrentCabin(args);
    }

    const bumpCarUpdate = (event) => {

        const clickItemID = parseInt(event.target.id);
        bumpcar1.current.style.zIndex = 0;
        bumpcar2.current.style.zIndex = 0;
        bumpcar3.current.style.zIndex = 0;
        bumpcar4.current.style.zIndex = 0;
        bumpcar5.current.style.zIndex = 0;
        bumpcar1.current.style.opacity = 0.75;
        bumpcar2.current.style.opacity = 0.75;
        bumpcar3.current.style.opacity = 0.75;
        bumpcar4.current.style.opacity = 0.75;
        bumpcar5.current.style.opacity = 0.75;
        if (clickItemID === 1) {
            bumpcar1.current.style.zIndex = 1;
            bumpcar1.current.style.opacity = 1;
        } else if (clickItemID === 2) {
            bumpcar2.current.style.zIndex = 1;
            bumpcar2.current.style.opacity = 1;
        } else if (clickItemID === 3) {
            bumpcar3.current.style.zIndex = 1;
            bumpcar3.current.style.opacity = 1;
        } else if (clickItemID === 4) {
            bumpcar4.current.style.zIndex = 1;
            bumpcar4.current.style.opacity = 1;
        } else if (clickItemID === 5) {
            bumpcar5.current.style.zIndex = 1;
            bumpcar5.current.style.opacity = 1;
        }
        setCurrentBumpCar(clickItemID);
    }

    return (

        <div className="midwayGame" >
            <div className='midwayContainer'>
                <div className='headerRow'>
                    <div className='pgTitle'>
                        <div className='gameTitleContainer'>
                            <div className='pgName'>Midway</div>
                            <div className='pgDesc'>Carnival Game</div>
                        </div>
                        <SlideDownInDiv>
                            <div className='hintContainer'>
                                <p>Recreate the carnival memory! Use the memories on these cards to adjust the rides and find the perfect combination.</p>
                            </div>
                        </SlideDownInDiv>
                    </div>
                </div>
                <div className='midwayGameContent'>
                    <div className='coasterBackground'></div>
                </div>

                <div className='gameClues' onClick={swapClue}>
                    <div className='clue1' ref={clue1}></div>
                    <div className='clue2' ref={clue2}></div>
                    <div className='clue3' ref={clue3}></div>
                </div>
                <div className='coasters' onClick={swapCoaster}>

                    <div className='coaster2' ref={coaster2}></div>
                    <div className='coaster3' ref={coaster3}></div>
                    <div className='coaster1' ref={coaster1}></div>
                </div>
                <div className='bumperCars'>
                    <div className='bumpCar1' id='1' onClick={bumpCarUpdate} ref={bumpcar1}></div>
                    <div className='bumpCar2' id='2' onClick={bumpCarUpdate} ref={bumpcar2}></div>
                    <div className='bumpCar3' id='3' onClick={bumpCarUpdate} ref={bumpcar3}></div>
                    <div className='bumpCar4' id='4' onClick={bumpCarUpdate} ref={bumpcar4}></div>
                    <div className='bumpCar5' id='5' onClick={bumpCarUpdate} ref={bumpcar5}></div>
                </div>
                <div className='ferrisWheelContainer'>
                    <div className='ferrisWheel'>
                    </div>
                    <Wheel updateCurrentCabin={updateCabin} />
                </div>

            </div>
            <div className='videoContainer'>
                <Timer seconds={props.seconds} gotoFailed={gotoFailed} isReversed={props.isReversed} setUpWarningSound={setUpWarningSound} timerRef={timerRef} updateTimerValue={props.updateTimerValue} />

                <Video VideoURL="./videos/5_2_Minigame_Intro.mp4" actorName={actorName} actorTitle={actorTitle} poster={posterURL} updateVideoStatue={updateVideoStatue} playVideo={playVideo} />
                <div className='helpContainer'>
                    <div className='helpButton' onClick={openModal}></div>
                    <Modal
                        isOpen={modalIsOpen}
                        style={customStyles}
                        contentLabel="Food puzzle help"
                    >

                        <div className="helpPopup" onClick={closeModal}>
                            <div className='helpMessageContainer'>
                                <div className='helpLabel' />
                                <div className='whitePaperContainer' />
                                <div className='helpIcon' />
                                <div className='messageContainter'>
                                    <div className='helpMessage'>
                                        <div className='helpTitle'>Recreate the carnival memory!</div>
                                        <div className='helpDesc'>
                                        </div>
                                    </div>
                                    <div className='helpButtonsContainer'>
                                        <button className='revealButton' onClick={showClear} >Click to reveal the clue!</button>
                                        <div className={`blurredClue ${isBlur}`}>
                                            <div>
                                                The ferris wheel needs the car with four stars to be at the very top. Choose the blue bumper car and see if you can guess the correct roller coaster colour!
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        isOpen={gameOverModalIsOpen}
                        style={customStyles}
                        contentLabel="Game over"
                    >

                        <div className="timeOutPopup">
                            <div className='timeoutContainer'>
                                <div className='timeoutLabel' />
                                <div className='paperContainer' />
                                <div className='timeoutPictures'>
                                    <div className='pic1'></div>
                                    <div className='pic2'></div>
                                    <div className='pic3'></div>
                                </div>
                                <div className='timeoutMessage'>
                                    Oops you've run out of time!
                                </div>
                                <div className='timoutButtonsContainer'>
                                    <button className='timeoutButton' onClick={closeGameOverModal} >Continue?</button>
                                    <button className='timeoutButton' onClick={restartGame}>Restart</button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
                <div>
                    <form onSubmit={handleSubmit}>
                        <input className="submitButton" onClick={handleSubmit} ref={btnRef} type="submit" value="Confirm" />
                    </form>
                </div>
            </div>
            <Audio AudioURL="./musics/the-crackdown.mp3" autoPlay loop updateAudioStatue={updateAudioStatue} playAudio={playAudio} />
        </div>
    );

};

export default memo(MidwayGame);